import { render, staticRenderFns } from "./paperStatistics.vue?vue&type=template&id=60b72702&scoped=true"
import script from "./paperStatistics.vue?vue&type=script&lang=js"
export * from "./paperStatistics.vue?vue&type=script&lang=js"
import style0 from "./paperStatistics.vue?vue&type=style&index=0&id=60b72702&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b72702",
  null
  
)

export default component.exports